import { render, staticRenderFns } from "./VText.vue?vue&type=template&id=0ed04a3e&scoped=true"
import script from "./VText.vue?vue&type=script&lang=js"
export * from "./VText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed04a3e",
  null
  
)

export default component.exports